import { ComponentPropsWithoutRef } from 'react';

export default function MoveVerticalIcon(
  props: ComponentPropsWithoutRef<'svg'>,
) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 12 4"
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={4}
      {...props}
    >
      <path
        fill="currentColor"
        d="m12 4h-12v-1h12zm0-3h-12l-1.7764e-15 -1h12z"
      />
    </svg>
  );
}
